module.exports = __webpack_public_path__ + "static/img/Partner.3cb2a25.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Partner.png
// module id = AUwx
// module chunks = 13